<template>
    <b-row>
        <b-col cols="2">
            <b-nav
                pills
                vertical
                class="text-center"
            >
                <b-nav-item
                    v-for="item in navItems"
                    :key="item.location.name"
                    :to="item.location"
                    exact-active-class="active"
                >
                    <slot
                        name="nav-item"
                        :item="item"
                    >
                        {{ $t(`${item.location.name}.nav`) }}
                    </slot>
                </b-nav-item>
            </b-nav>
        </b-col>

        <b-col
            cols="6"
            offset-lg="1"
        >
            <keep-alive>
                <router-view v-bind="$attrs" />
            </keep-alive>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'SideNavRouterView',
    props: {
        navItems: {
            type: Array,
            required: true,
            validator(items) {
                return items.every(i => !!i.location);
            },
        },
    },
};
</script>
